module.exports = __webpack_public_path__ + "static/media/Government House, Lahore c. 1910 (Postcard).57b611c1.jpg";